const particlesBlackConfig= {
  "background": {
    "color": "#121212"
  },
  "interactivity": {
    "events": {
      "onClick": {
        "enable": true,
        "mode": "repulse"
      },
      "onHover": {
        "enable": true,
        "mode": "bubble"
      },
      "resize": true
    },
    "modes": {
      "bubble": {
        "distance": 1,
        "size": 0,
        "duration": 2,
        "opacity": 0,
        "speed": 3,
      },
      "repulse": {
        "distance": 400,
        "duration": 0.4
      }
    }
  },
  "particles": {
    "color": {
      "value": "#ffffff"
    },
    "collisions": {
      "enable": false
    },
    "move": {
      "direction": "none",
      "enable": true,
      "outModes": {
        "default": "bounce"
      },
      "random": false,
      "speed": 1,
      "straight": false
    },
    "number": {
      "density": {
        "enable": true
      },
      "value": 130
    },
    "opacity": {
      "value": 0.2
    },
    "shape": {
      "type": "circle"
    },
    "size": {
      "random": true,
      "value": 1.8
    }
  }
};

export default particlesBlackConfig